import { useState, useEffect } from 'react';

export default function Product({ product }) {
  const [currentImage, setCurrentImage] = useState(null);

  useEffect(() => {
    if (product?.image_urls && product.image_urls.length > 0) {
      const randomIndex = Math.floor(Math.random() * product.image_urls.length);
      setCurrentImage(product.image_urls[randomIndex]);
    }
  }, [product]);

  const reshuffleImage = () => {
    if (product?.image_urls && product.image_urls.length > 1) {
      const randomIndex = Math.floor(Math.random() * product.image_urls.length);
      setCurrentImage(product.image_urls[randomIndex]);
    }
  };

  return (
    <div className='w-full max-w-2xs md:w-60 bg-white rounded-md shadow-md overflow-hidden font-sans border border-[var(--color-yellow-primary)] transition duration-300 ease-in-out transform hover:-translate-y-1'>
      <figure
        className='w-full h-52 cursor-pointer'
        onClick={reshuffleImage}
        title='Click to see another image'
      >
        {currentImage && (
          <img
            src={currentImage?.url}
            alt={currentImage?.filename || 'Product Image'}
            className='w-full md:h-full object-contain'
          />
        )}
      </figure>

      <div className='pt-4 pb-2 px-2 '>
        <h3
          className='text-gray-800 text-base font-normal truncate'
          title={product?.name}
        >
          {product.name?.toString()}
        </h3>
        <div className='flex items-center gap-3 mt-1'>
          <p className='text-lg font-bold text-black'>
            GHS {product?.price?.toString()}
          </p>
        </div>
      </div>
    </div>
  );
}
